import { t } from "../../../languages";
import { genExerciseComponent } from "../../../utils/componentwrapper";

import './index.less'

const ExerciseSolution = ({ lang, title, exercise }) => {
    // console.log('ExerciseSolution exercise:', exercise);
    
    exercise.params.showSolution= true; // Force showing the result in the component
    
    return (
        <section className="exercise-solution">
            <h2>{t(lang, title)}</h2>
            <div className="exercise-solution-content">
                {genExerciseComponent(exercise.impl, 'comp', 1, exercise.params, ()=>console.log('cancel...'), ()=>console.log('Save result...'), lang)}
            </div>
        </section>
    );
}

export default ExerciseSolution;